<script setup lang="ts">
import { focusNextSiblingOnRemove } from "@carnet/ui/utils/focusOnRemove";

defineProps<{ label: string }>();
const emit = defineEmits<{ remove: [] }>();
const { t } = useI18n();
</script>

<template>
  <UButton
    color="secondary"
    variant="solid"
    trailing-icon="icon:close"
    class="shrink-0"
    :aria-label="t('ui.filters.remove', { name: label })"
    @click="(e) => focusNextSiblingOnRemove(e, () => emit('remove'))"
  >
    {{ label }}
  </UButton>
</template>
